import { useRecoilState, useRecoilValue } from "recoil";
import {
  cameraToggleState,
  imgBase64State,
  imgFileState,
  isEditState
} from "../../../../recoil/contentsAtom";
import { IMAGE_DNS } from "../../../../utils/config/Config";

function PopPagePhotos() {
  const [cameraToggle, setCameraToggle] = useRecoilState(cameraToggleState);
  const [imgBase64, setImgBase64] = useRecoilState(imgBase64State);
  const [imgFile, setImgFile] = useRecoilState(imgFileState);

  const isEdit = useRecoilValue(isEditState);

  const cancelImage = () => {
    setImgBase64([]);
    setCameraToggle(false);
    setImgFile(null);
  };

  return (
    <div className="btn-wrap photogrid">
      {cameraToggle ? (
        <div className="wrap-photogrid">
          {isEdit || (imgFile !== null && imgFile !== undefined)
            ? imgBase64.map((i) => (
                <img src={i} key={i} className="upload-img" />
              ))
            : null}
          <img
            className="btn-layer-close"
            src={
              IMAGE_DNS +
              "/Valofe_file/web/vfun-ko/images/common/icon/icon-page-pop-close-btn.png"
            }
            onClick={cancelImage}
            alt="포토 이미지 닫기"
          />
        </div>
      ) : null}
    </div>
  );
}

export default PopPagePhotos;
